import styled from 'styled-components'

export const TextBold = styled.span`
  font-weight: 700;
`